import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {


  title?: string;
  message: string;
  yes?: string;
  no?: string;
  constructor(@Inject(MAT_DIALOG_DATA) data: any) {
    this.title = data.title;
    this.message = data.message;
    this.yes = data.yes;
    this.no = data.no;
  }

  ngOnInit(): void {
  }

}
